/**
 * Enum for Twilio voice call status states in the dialer
 */
export enum TwilioCallStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  CONNECTING = 'connecting',
  RINGING = 'ringing',
  CONNECTED = 'connected',
  RECONNECTING = 'reconnecting',
  DISCONNECTED = 'disconnected',
  CANCELLED = 'cancelled',
}
